export const ButtonSize = {
  MICRO: "micro",
  SMALL: "small",
  DEFAULT: "default",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge",
};

export const IconSize = {
  MICRO: "micro",
  SMALL: "small",
  DEFAULT: "default",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge",
  XXLARGE: "xxlarge",
  XXXLARGE: "xxxlarge",
  XXXXLARGE: "xxxxlarge",
};
